(function () {
  let scheduled = false;
  let running = false;
  let lastRun = 0;

  function getVariants() {
    const el = document.getElementById("uvp-variants-json");
    if (!el) return null;
    try {
      const data = JSON.parse(el.textContent);
      return Array.isArray(data.variants) ? data.variants : [];
    } catch (e) {
      return null;
    }
  }

  function norm(s) {
    return String(s || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function ensureBadge(labelEl) {
    let b = labelEl.querySelector(".tz24-variant-badge");
    if (!b) {
      b = document.createElement("span");
      b.className = "tz24-variant-badge";
      labelEl.appendChild(b);
    }
    return b;
  }
  function decorate(variants) {
    const radios = document.querySelectorAll('input.opt-btn[type="radio"]');
    if (!radios.length) return;

    // Map: variant title -> pct
    const pctByTitle = new Map();
    variants.forEach(v => pctByTitle.set(norm(v.title), Number(v.discount_percent || 0)));

    radios.forEach((radio) => {
        if (!radio.id) return;

        const label = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
        if (!label) return;

        const key = norm(radio.value || label.textContent);
        const pct = pctByTitle.get(key) || 0;

        const badge = ensureBadge(label);

        // Reset immer zuerst (damit nichts "hängen bleibt")
        badge.innerHTML = "";
        badge.removeAttribute("style"); // ganz wichtig
        label.classList.remove("tz24-variant-discounted");

        if (pct > 0) {
        // Cleanes "Deal" Icon (ohne Text, ohne Prozent)
        badge.innerHTML = `
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M20.59 13.41 12 4.83V4H4v8h.83l8.58 8.59a2 2 0 0 0 2.83 0l4.35-4.35a2 2 0 0 0 0-2.83ZM6 10V6h4l8.17 8.17-2.94 2.94L6 10Zm3-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>
            </svg>
        `;
        badge.title = "Angebot";
        badge.setAttribute("aria-label", "Angebot");

        // Anzeige übernimmt CSS über .tz24-variant-discounted
        label.classList.add("tz24-variant-discounted");
        }
    });
  }


  function run() {
    const now = Date.now();
    if (running) return;

    // Hard throttle: max 1x pro 200ms
    if (now - lastRun < 200) return;
    lastRun = now;

    const variants = getVariants();
    if (!variants) return;

    running = true;
    try {
      decorate(variants);
    } finally {
      running = false;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  function observeScoped() {
    // Scope: nur im Bereich wo die Option Buttons sind, nicht document.body
    const container =
      document.querySelector(".option-selector__btns") ||
      document.querySelector(".option-selector") ||
      document.querySelector(".product__info-wrapper") ||
      document.querySelector("main");

    if (!container) return;

    const obs = new MutationObserver(() => schedule());
    obs.observe(container, { childList: true, subtree: true });

    // Nach kurzer Zeit wieder stoppen, damit es nie eskaliert
    setTimeout(() => obs.disconnect(), 5000);
  }

  document.addEventListener("DOMContentLoaded", () => {
    schedule();
    observeScoped();
    setTimeout(schedule, 300);
    setTimeout(schedule, 900);
  });

  document.addEventListener("change", () => schedule());
})();
